import { useCallback, useContext } from 'react'
import { PreferencesContext } from './preferencesContext'
import { translations } from './preferencesConstants'

export function useTranslation() {
  const ctx = useContext(PreferencesContext)
  const language = ctx ? ctx.language : 'de'
  const t = useCallback(
    (key) => {
      const dict = translations[language] || translations.en
      return dict[key] ?? translations.en[key] ?? key
    },
    [language]
  )
  return { t, language }
}
